import logoFull from "@/assets/brand/diamond-logo.jpg";
import logoIcon from "@/assets/brand/diamond-icon.png";

/**
 * Central brand component — the ONLY place the official BDVG AI logo is referenced.
 * variant="icon" uses the tightly-cropped central diamond (for small sizes / avatars).
 * variant="full" uses the complete original logo.
 */
export function BrandMark({ variant = "icon", size = 40, glow = false, className = "" }) {
  const src = variant === "full" ? logoFull : logoIcon;
  return (
    <span
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      data-testid="brand-mark"
    >
      {glow && (
        <span
          className="absolute inset-0 rounded-full blur-xl animate-pulse-glow"
          style={{ background: "radial-gradient(circle, rgba(212,175,55,0.35), transparent 70%)" }}
        />
      )}
      <img
        src={src}
        alt="BDVG AI"
        draggable={false}
        className="relative z-10 h-full w-full object-contain select-none"
      />
    </span>
  );
}

export function BrandLogo({ size = 34, showText = true, textClass = "", glow = false, subtitle = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <BrandMark variant="icon" size={size} glow={glow} />
      {showText && (
        <div className="flex flex-col leading-none">
          <span className={`font-heading font-bold tracking-tight ${textClass}`}>
            BDVG<span className="text-gradient-gold"> AI</span>
          </span>
          {subtitle && (
            <span className="mt-1 text-[10px] uppercase tracking-[0.28em] text-gold/60">
              Think · Create · Build
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default BrandLogo;
